export default __webpack_public_path__ + "static/media/tripod-closed.00b3c684.png";